import { SubmitHandler } from "react-hook-form";
import { ILoginFormModel } from "../models/loginFormModel";
import { useLoginForm } from "./useLoginForm";
import { useNavigate } from "react-router-dom";
import useSignIn from "react-auth-kit/hooks/useSignIn";
import { useEffect } from "react";
import { useApiMutation } from "../../../../common/infrastructure/hooks/useApiMutation";
import { useAppContext } from "../../../../AppContext";
import { getDefaultRoutePath } from "../../../../common/infrastructure/routes/routePaths";
import { endpointsMetadata } from "../../../../common/infrastructure/routes/endpointsMetadata";
import { IUserModel } from "../../../../common/infrastructure/hooks/useAuthentication";

export const useLoginPage = () => {
  const form = useLoginForm();
  const navigate = useNavigate();
  const { mutate } = useApiMutation();

  const { isAuthenticated, resetStudios, currentUser } = useAppContext();
  const signIn = useSignIn();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(getDefaultRoutePath(currentUser));
    }
  }, [isAuthenticated]);

  const onSave: SubmitHandler<ILoginFormModel> = async (data) => {
    mutate(
      {
        endpoint: endpointsMetadata.authentication.login,
        globalIsLoading: true,
        method: "post",
        disableSuccessToast: true,
        ...data,
      },
      {
        onSuccess: (data) => {
          const currentUser = data as IUserModel;
          if (currentUser) {
            if (
              signIn({
                auth: {
                  token: currentUser.authToken,
                  type: "Bearer",
                },
                userState: currentUser,
              })
            ) {
              resetStudios();
              navigate(getDefaultRoutePath(currentUser));
            }
          }
        },
      }
    );
  };

  return { form, onSave };
};
